<template>
  <footer class="full-width">
    <div class="container">
        <div class="footer-content">
            <div class="footer-col"  style="width: 40%;">
                <img src="./../assets/images/footer_logo.png" alt="logo" class="footer-logo">
                <h1>{{ $t('footer.followUs') }}</h1>
                <p>{{ $t('footer.email') }}</p>
                <p class="location">{{ $t('footer.address') }}</p>
            </div>
            <div class="footer-col">
                <div class="footer-link-title" @click="toPage('/index', 0)">{{ $t('footer.home') }}</div>
                <div class="footer-links">
                    <a href="javascript:;" @click="toPage('/marketArea', 0)">{{ $t('footer.marketArea') }}</a>
                    <a href="javascript:;" @click="toPage('/productCenter', 0)">{{ $t('footer.productCenter') }}</a>
                    <a href="javascript:;" @click="toPage('/serviceSupport', 0)">{{ $t('footer.serviceSupport') }}</a>
                    <a href="javascript:;" @click="toPage('/contactUs', 0)">{{ $t('footer.contactUs') }}</a>
                </div>
            </div>
            <div class="footer-col">
                <div class="footer-link-title" @click="toPage('/marketArea', 0)">{{ $t('footer.marketArea') }}</div>
                <div class="footer-links">
                    <a href="javascript:;" @click="toPage('/marketArea/chemicalEngineering', 650)">{{ $t('footer.market.chemical') }}</a>
                    <a href="javascript:;" @click="toPage('/marketArea/spaceflight', 650)">{{ $t('footer.market.spaceflight') }}</a>
                    <a href="javascript:;" @click="toPage('/marketArea/electron', 650)">{{ $t('footer.market.electron') }}</a>
                    <a href="javascript:;" @click="toPage('/marketArea/AI', 650)">{{ $t('footer.market.AI') }}</a>
                    <a href="javascript:;" @click="toPage('/marketArea/transportation', 650)">{{ $t('footer.market.transportation') }}</a>
                    <a href="javascript:;" @click="toPage('/marketArea/newEnergy', 650)">{{ $t('footer.market.newEnergy') }}</a>
                    <a href="javascript:;" @click="toPage('/marketArea/architecture', 650)">{{ $t('footer.market.architecture') }}</a>
                    <a href="javascript:;" @click="toPage('/marketArea/homeAppliances', 650)">{{ $t('footer.market.homeAppliances') }}</a>
                </div>
            </div>
            <div class="footer-col">
                <div class="footer-link-title" @click="toPage('/productCenter', 0)">{{ $t('footer.productCenter') }}</div>
                <div class="footer-links">
                    <a href="javascript:;" @click="toPage('/productCenter/productInfo', 650)">{{ $t('footer.product.heatConduction') }}</a>
                    <a href="javascript:;" @click="toPage('/productCenter/productInfo', 650)">{{ $t('footer.product.heatInsulation') }}</a>
                    <a href="javascript:;" @click="toPage('/productCenter/productInfo', 650)">{{ $t('footer.product.thermalInsulation') }}</a>
                    <a href="javascript:;" @click="toPage('/productCenter/productInfo', 650)">{{ $t('footer.product.fireproof') }}</a>
                    <a href="javascript:;" @click="toPage('/productCenter/productInfo', 650)">{{ $t('footer.product.insulation') }}</a>
                    <a href="javascript:;" @click="toPage('/productCenter/productInfo', 650)">{{ $t('footer.product.electricHeating') }}</a>
                    <a href="javascript:;" @click="toPage('/productCenter/productInfo', 650)">{{ $t('footer.product.dielectric') }}</a>
                    <a href="javascript:;" @click="toPage('/productCenter/productInfo', 650)">{{ $t('footer.product.electricConduction') }}</a>
                </div>
            </div>
            <div class="footer-col">
                <div class="footer-link-title" @click="toPage('/contactUs', 0)">{{ $t('footer.contactUs') }}</div>
                <div class="footer-links">
                    <a href="javascript:;" @click="toPage('/contactUs', 650)">{{ $t('footer.contact.contactInfo') }}</a>
                    <a href="javascript:;" @click="toPage('/contactUs', 650)">{{ $t('footer.contact.companyAddress') }}</a>
                    <a href="javascript:;" @click="toPage('/contactUs', 1820)">{{ $t('footer.contact.joinUs') }}</a>
                </div>
            </div>
        </div>
        <div class="copyright">
            {{ $t('footer.copyright') }}
        </div>
    </div>
</footer>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    toPage (path, position) {
        document.querySelector('body').scroll(0, position)
        this.$router.push(path)
    },
  }
}
</script>

<style scoped>
/* 页脚区域 */
footer {
    background-color: #333;
    color: #ccc;
    padding: 60px 0 30px;
    font-size: 12px;
}
.container {
    width: 1200px;
    margin: 0 auto;
}
.footer-content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
}

.footer-col {
    width: 20%;
}

.footer-logo {
    height: 40px;
    margin-bottom: 50px;
}

.footer-col h1{
  color: rgba(255, 255, 255, 1);
  font-weight: 600;
  font-size: 22px;
  line-height: 31px;
}

.footer-col p{
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    line-height: 22px;
    padding-top: 24px;
}

.footer-col p.location {
    padding-top: 16px;
}

.footer-link-title {
    font-size: 14px;
    color: #fff;
    margin-bottom: 15px;
    cursor: pointer;
}

.footer-links a {
    display: block;
    margin-bottom:16px;
    font-size: 14px;
    line-height: 21px;
    color: #fff;
    opacity: 0.5;
    text-decoration: none;
}

.copyright {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #444;
    margin-top: 20px;
}
</style>
